import { HotelBasicFacilities, HotelBasicFacilityGroups, MappedFacilitiesIdsByGroupId } from '../models/hotel-info';

export const basicFacilitiesGroupsIds = [
    HotelBasicFacilityGroups.BeachLine,
    HotelBasicFacilityGroups.Internet,
    HotelBasicFacilityGroups.Transportation,
    HotelBasicFacilityGroups.ChildrenServices,
    HotelBasicFacilityGroups.Health,
    HotelBasicFacilityGroups.RoomsAmenities
];

export const mappedBasicHotelFacilitiesIds: MappedFacilitiesIdsByGroupId = {
    [HotelBasicFacilityGroups.Internet]: [
        HotelBasicFacilities.WiFiOnAllArea,
        HotelBasicFacilities.WiFiInRoom,
        HotelBasicFacilities.BeachWiFi,
        HotelBasicFacilities.WiFi,
        HotelBasicFacilities.WiFiInLobby
    ],
    [HotelBasicFacilityGroups.Transportation]: [HotelBasicFacilities.Transfer],
    [HotelBasicFacilityGroups.ChildrenServices]: [
        HotelBasicFacilities.ChildrenPlayingRoom,
        HotelBasicFacilities.ChildrensPool,
        HotelBasicFacilities.ChildrenWaterSlides,
        HotelBasicFacilities.ChildrenPlayground,
        HotelBasicFacilities.ChildrenMenu
    ],
    [HotelBasicFacilityGroups.Health]: [HotelBasicFacilities.DoctorsOffice],
    [HotelBasicFacilityGroups.RoomsAmenities]: [HotelBasicFacilities.Safe]
};

export const facilitiesGroupIdsOrder = [6, 20, 10, 19, 8, 13, 22, 1, 18, 5, 14, 15, 23, 2, 3, 4, 21, 9, 11, 16, 7, 12];
